// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".return-skeleton[data-v-0953b3f2]{height:120px;display:flex;gap:20px}.return-skeleton__inner[data-v-0953b3f2]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
